import { useEffect, useState } from "react";
import api from "../utils/api";

// Stripe-hosted Customer Portal login page (set on the server as STRIPE_PORTAL_LOGIN_URL).
// Donors and sponsors who paid without an account enter their email there, get a magic
// link, and can cancel or update a recurring payment themselves. "" until loaded or when
// not configured, so callers can simply hide the link.
let cached = null;

export default function usePortalLoginUrl() {
  const [url, setUrl] = useState(cached || "");

  useEffect(() => {
    if (cached !== null) return;
    let alive = true;
    api.get("/api/payments/portal-login-url")
      .then((res) => {
        cached = res.data?.url || "";
        if (alive) setUrl(cached);
      })
      .catch(() => { cached = ""; });
    return () => { alive = false; };
  }, []);

  return url;
}
